var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEspumillon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3591,
    height: 724,
    viewBox: "0 0 3591 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3359.38 481.792C3310.16 329.197 3197.34 59.4494 3139.75 201.215V297.202C3139.75 321.198 3017.94 81.2312 2857.37 101.536C2782.87 110.958 2810.31 150.641 2866.67 192.278C2828.71 176.984 2798.63 174.497 2794.62 201.215C2792.47 215.527 2793.61 229.118 2796.91 241.723C2735.28 164.039 2661.89 87.3803 2641.43 121.84C2613.38 169.095 2674.04 289.202 2707.88 343.349L2641.43 323.044C2640.82 297.201 2629.99 245.885 2591.6 247.362C2553.21 248.838 2539.93 281.204 2538.08 297.202L2545.46 356.27C2501.78 249.823 2401.87 49.8514 2351.67 101.536C2320.13 134.009 2327.74 179.84 2345.38 218.429C2307.09 162.784 2255.32 101.536 2218.79 101.536C2168.59 101.536 2186.8 167.989 2202.18 201.215C2147.42 144.607 2026.47 34.7138 1980.7 48.0043C1963.97 52.8634 1960.87 68.5627 1965.32 88.7513C1939.2 50.1724 1911.89 25.3864 1893.96 48.0043C1860 90.8297 1869.97 167.989 1879.19 201.215C1863.2 171.065 1822.72 117.41 1788.76 143.991C1756.13 169.533 1741.33 206.21 1737.5 223.233C1753.33 146.932 1767.5 -1.45321 1700.17 0.0107528C1632.25 1.48747 1652.18 154.451 1670.64 230.749C1655.26 167.373 1613.79 45.7892 1570.98 66.4633C1532.3 85.1371 1559.98 171.48 1583.83 224.287C1566 189.345 1533.76 141.902 1504.53 149.529C1501.17 150.406 1498.34 151.964 1495.98 154.097C1486.87 106.885 1469.42 71.265 1438.09 84.9223C1395.95 103.295 1384.85 174.858 1384.82 235.07C1378.83 174.319 1364.35 110.572 1334.74 129.224C1294.87 154.328 1291.06 243.055 1294.13 284.28C1270.75 168.603 1211.82 -47.2443 1163.09 14.778C1114.37 76.8003 1171.09 220.288 1205.54 284.28L1122.49 239.978C1130.49 182.14 1136.15 66.4633 1094.81 66.4633C1053.46 66.4633 1013.6 205.521 998.833 275.05C990.836 220.288 964.874 111.503 925.009 114.457C916.467 115.09 910.71 120.592 907.088 129.382C895.635 79.6593 876 43.4051 843.801 55.3879C808.426 68.553 790.507 121.299 782.32 177.991C782.131 92.5737 773.257 9.93911 742.292 14.778C700.558 21.2999 707.592 158.879 719.129 250.692C704.2 152.092 673.716 13.2271 640.783 55.3879C631.997 66.6362 626.87 81.4545 624.408 98.1698C610.441 46.1821 591.274 14.565 566.958 48.0043C519.71 112.98 538.659 217.827 554.039 262.129C489.442 165.527 353.974 -1.83392 328.873 101.536C314.75 159.697 345.54 202.665 386.13 231.755C322.688 211.646 263.356 204.997 264.277 247.362C264.938 277.768 286.331 296.98 314.454 308.706C272.973 306.473 234.573 310.263 217.775 327.047C166.546 309.537 125.695 305.455 129.546 337.811C132.394 361.732 141.373 379.649 152.671 392.811C79.9868 354.136 -1.74097 320.237 22.5005 371.037C50.3103 429.314 122.76 448.39 165.81 451.703C95.8081 449.76 -17.1621 460.156 2.19849 516.863C22.8696 577.409 138.775 533.477 194.143 503.942C110.475 549.474 -31.7607 642.754 68.6409 651.614C103.674 654.706 130.738 647.1 151.337 634.16C133.497 671.731 127.735 703.3 157.231 703.3C211.861 703.3 279.657 623.31 306.726 583.316C280.887 633.155 242.867 730.988 297.498 723.604C334.265 718.635 355.817 676.599 367.106 636.323C363.777 673.393 370.019 706.164 404.544 690.378C456.221 666.751 491.288 556.243 502.362 503.942C491.903 554.397 481.322 653.091 522.663 644.231C533.574 641.892 543.439 633.246 552.198 620.89C547.317 655.208 557.132 672.65 598.334 644.231C683.97 585.162 733.679 458.41 747.829 402.418C762.594 401.187 790.647 406.478 784.741 437.49C778.835 468.501 777.359 503.327 777.359 516.863C776.744 540.86 786.956 574.456 832.728 516.863C878.499 459.271 910.859 409.186 921.317 391.342L967.458 371.037C953.308 393.188 925.009 444.135 925.009 470.716C925.009 503.942 877.022 548.244 937.928 526.093C984.276 509.237 1034.3 464.321 1056.54 440.914C1023.9 476.304 976.917 540.86 1028.36 540.86C1081.52 540.86 1140.33 471.946 1163.09 437.49L1187.09 487.329C1144.02 517.479 1065.28 582.947 1094.81 603.621C1124.34 624.295 1224 554.397 1270.14 516.863L1310.74 470.716C1285.52 531.015 1245.04 651.614 1284.9 651.614C1324.77 651.614 1388.87 542.091 1415.94 487.329H1458.39C1431.94 555.012 1394.9 690.378 1458.39 690.378C1511.37 690.378 1546.62 596.121 1563.27 525.586C1561.64 551.037 1567.05 579.479 1591.28 594.391C1624.62 614.915 1652.03 544.999 1665.51 492.804C1655.68 543.768 1655.62 613.84 1713.09 603.621C1779.53 591.807 1826.9 464.563 1842.28 402.418C1841.67 447.95 1851.14 525.355 1893.96 470.716C1936.78 416.077 1975.78 371.652 1989.93 356.27C1954.86 401.802 1894.33 497.666 1932.72 516.863C1971.11 536.061 2088.98 417.8 2143.12 356.27L2176.34 391.342C2105.59 462.717 1989.56 603.252 2091.44 594.391C2193.32 585.531 2264.31 486.098 2287.08 437.49L2368.28 424.568C2317.22 458.41 2231.71 533.846 2298.15 564.857C2364.59 595.868 2419.34 502.712 2438.42 452.257L2469.79 470.716C2397.81 539.63 2273.42 674.873 2351.67 664.536C2449.49 651.614 2545.46 570.394 2545.46 526.093C2545.46 490.652 2576.22 505.173 2591.6 516.863C2563.3 566.088 2518.89 664.536 2567.61 664.536C2611.62 664.536 2668.98 589.243 2699.16 540.665C2665.8 598.173 2624.04 690.378 2672.81 690.378C2725.96 690.378 2829.07 566.088 2873.98 503.942L2910.9 470.716L2892.44 594.391C2899.21 614.696 2919.39 650.138 2945.96 629.464C2972.54 608.789 2974.26 515.018 2971.8 470.716L3006.87 452.257L3016.1 526.093C3063.47 612.85 3149.72 747.97 3115.76 594.391C3081.8 440.812 3081.92 417.185 3086.23 424.568C3134.22 502.712 3229.45 638.324 3226.5 555.627C3223.54 472.931 3241.26 442.412 3250.49 437.49C3249.87 518.709 3256.4 665.643 3287.4 603.621C3299.3 579.825 3305.6 564.325 3308.43 554.537C3336.92 641.169 3389.67 771.619 3403.68 690.378C3418.44 604.728 3392.6 555.012 3377.84 540.86C3406.94 561.78 3485.44 598.081 3566.65 575.922C3647.85 553.762 3505.74 503.935 3424.54 481.792C3459.6 464.56 3526.78 413.851 3514.97 348.876C3505.55 297.074 3449.92 354.468 3407.07 411.052C3442.35 356.339 3469.96 291.406 3409.77 297.202C3332.99 304.595 3344.19 423.342 3359.38 481.792Z",
    fill: "#548D7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.207 299.241L541.182 331.985",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.941 398.382L520.258 362",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M614.832 492.859L576.625 363.373",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M514.824 474.298L547.512 385.532",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.738 380.191L334.713 412.935",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M926.16 143.708L934.883 278.432",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.477 479.332L313.793 442.95",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M838.664 195.575L899.922 267.653",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.367 573.809L370.16 444.323",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M804.102 397.605L915.788 321.759",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.363 555.248L341.052 466.482",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M791.305 296.697L885.809 300.783",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1708.39 221.93L1779.2 336.872",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1655.38 308.74L1743.26 343.725",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.48 503.423L1782.62 384.095",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.91 420.265L1746.31 379.606",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2825.43 252.854L2754.61 367.797",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2878.43 339.665L2790.55 374.65",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2814.33 534.348L2751.19 415.02",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2872.9 451.19L2787.49 410.531",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3070.38 414.196L3064.81 279.305",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2977.89 371.875L3031.18 293.722",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2920.03 441.172L2921.61 346.593",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3299.32 525.705L3300.91 431.125",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2726.31 593.012L2727.89 498.432",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1600.29 525.705L1601.87 431.125",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.3 370.904L1385.42 459.59",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.82 334.713L1141.94 423.4",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.73 412.935L1217.64 463.31",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1600.85 323.799L1628.76 374.174",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M647.648 438.402L675.553 488.777",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M532.996 590.456L574.825 550.874",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1471.64 512.234L1513.47 472.653",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2188.37 512.234L2230.2 472.653",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.387 566.807L269.215 527.226",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M563.973 511.443L553.728 454.774",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M380.246 389.563L370.002 332.895",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M443.914 502.348L433.669 445.679",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M606.672 598.939L617.561 542.39",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.12 585.905L1513.01 529.357",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.54 482.217L1800.43 425.668",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2124.25 534.97L2135.14 478.422",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2502.62 567.714L2513.51 511.165",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2762.75 602.277L2773.64 545.728",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2935.57 533.151L2946.46 476.603",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3019.24 414.91L3030.13 358.362",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3071.39 508.955L3039.84 460.779",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3135.17 355.603L3103.62 307.427",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3357.1 552.065L3325.55 503.889",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3413.41 496.419L3356.23 503.256",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M829.055 476.759L839.944 420.211",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M328.805 640.478L339.694 583.929",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1645.2 230.415L1599.95 147.347",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.7 319.551L1323.45 236.483",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2922.15 174.633L3041.23 238.244",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2920.1 276.326L3013.64 262.269",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2501 479.684L2495.43 344.793",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2408.51 437.362L2461.8 359.21",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2352.77 240.121L2471.85 303.731",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2350.72 341.813L2444.27 327.756",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2029.11 407.187L2108.41 297.925",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1982.81 316.62L2073.09 288.375",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M2061.44 127.337L2115.39 251.096",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1996.76 205.83L2078.85 252.827",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.03 414.463L1948.33 305.201",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.73 323.896L1913.01 295.652",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1901.36 134.613L1955.31 258.372",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1836.68 213.106L1918.77 260.103",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.01 441.712L1560.89 307.896",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1459.25 384.006L1525.28 316.269",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.53 180.09L1544.79 263.371",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.89 279.889L1513.46 282.252",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.63 529.029L1353.52 395.213",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.87 471.323L1317.9 403.586",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.15 267.407L1337.41 350.688",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.52 367.205L1306.08 369.568",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.87 480.373L1127.65 370.025",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.32 390.453L1092.2 360.963",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.32 200.101L1133.98 323.101",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.73 279.481L1097.47 325.339",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M692.066 439.581L716.981 306.894",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M611.461 377.538L680.968 313.377",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M601.523 172.814L703.243 261.582",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M576.652 271.436L670.96 278.783",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2211.4 436.667L2286.88 343.225",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M2642.27 551.389L2677.94 458.305",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M3211.65 449.52L3247.32 356.436",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M2177.46 355.06L2257.08 333.492",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M2594.59 495.653L2651.92 458.249",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M2408.48 578.53L2465.81 541.126",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M3163.97 393.784L3221.31 356.379",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2257.6 191.005L2295.95 302.173",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M2615.88 345.628L2674.6 423.573",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M3185.25 243.759L3243.98 321.704",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2196.74 257.847L2264.37 302.347",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2584.93 413.974L2649.71 431.794",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M3154.31 312.104L3219.09 329.925",
    stroke: "#2A5B4E",
    strokeWidth: 14.5528,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 2779.14 584.62)",
    fill: "#DC3A3A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 2761.64 527.498)",
    fill: "url(#paint0_radial_119_1147)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 3097.9 321.348)",
    fill: "#DC3A3A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 3080.4 264.225)",
    fill: "url(#paint1_radial_119_1147)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 2465.53 308.442)",
    fill: "#DC3A3A"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 2448.03 251.319)",
    fill: "url(#paint2_radial_119_1147)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 1875.75 436.207)",
    fill: "#DC3A3A"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 1858.25 379.084)",
    fill: "url(#paint3_radial_119_1147)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 1405.99 252.948)",
    fill: "#DC3A3A"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 1388.49 195.826)",
    fill: "url(#paint4_radial_119_1147)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 1052.38 526.545)",
    fill: "#DC3A3A"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 1034.88 469.423)",
    fill: "url(#paint5_radial_119_1147)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 689.73 206.489)",
    fill: "#DC3A3A"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 672.234 149.366)",
    fill: "url(#paint6_radial_119_1147)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1573,
    cy: 41.2977,
    rx: 45.1573,
    ry: 41.2977,
    transform: "matrix(0 -1 -1 0 289.66 560.1)",
    fill: "#DC3A3A"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5496,
    cy: 9.77764,
    rx: 10.5496,
    ry: 9.77764,
    transform: "matrix(0 -1 -1 0 272.16 502.977)",
    fill: "url(#paint7_radial_119_1147)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 2857.86 308.442)",
    fill: "#ECB921"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 2834.85 233.323)",
    fill: "url(#paint8_radial_119_1147)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 3266.96 530.417)",
    fill: "#ECB921"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 3243.96 455.298)",
    fill: "url(#paint9_radial_119_1147)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 2364.87 535.579)",
    fill: "#ECB921"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 2341.86 460.46)",
    fill: "url(#paint10_radial_119_1147)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 1918.34 202.617)",
    fill: "#ECB921"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 1895.33 127.498)",
    fill: "url(#paint11_radial_119_1147)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 1507.94 574.296)",
    fill: "#ECB921"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 1484.93 499.177)",
    fill: "url(#paint12_radial_119_1147)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 1074.32 211.651)",
    fill: "#ECB921"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 1051.31 136.531)",
    fill: "url(#paint13_radial_119_1147)"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3843,
    cy: 54.3087,
    rx: 59.3843,
    ry: 54.3087,
    transform: "matrix(0 -1 -1 0 587.777 594.945)",
    fill: "#ECB921"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8733,
    cy: 12.8581,
    rx: 13.8733,
    ry: 12.8581,
    transform: "matrix(0 -1 -1 0 564.77 519.825)",
    fill: "url(#paint14_radial_119_1147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5496 9.77764) rotate(90) scale(9.77764 10.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_119_1147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8733 12.8581) rotate(90) scale(12.8581 13.8733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspumillon);
export default __webpack_public_path__ + "static/media/espumillon.084daf5764e508d788da59c633bb2029.svg";
export { ForwardRef as ReactComponent };